module.exports = __webpack_public_path__ + "static/img/design.744f12b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-live/design.png
// module id = t97Z
// module chunks = 13